__turbopack_context__.v({
  "dotPulse": "DhsATq_dotPulse",
  "root": "DhsATq_root",
});
